import { FcShape, optionsDefaults } from '@dtx-company/flowcode-generator-browser'
import type { FcGeneratorOptions } from '@dtx-company/flowcode-generator-types'

/**
 * Checks if eye has branding
 * @param shape
 * @returns boolean
 */
const hasBranding = (shape?: FcShape): boolean => shape === FcShape.LOGO

/**
 * Modify passed in config to remove eye branding from any eye that has branding
 * @param options
 * @param {boolean} removeBrandedImage - Enables overriding of image url
 */
export const removeEyeBrandingFromConfig = (options: FcGeneratorOptions): void => {
  const positionElement = options.qrrotate ? 'positionElementTopRight' : 'positionElementBottomLeft'
  const hasTextBranding = hasBranding(
    options[positionElement]?.outerShape || optionsDefaults[positionElement]?.outerShape
  )

  if (hasTextBranding || options[positionElement]?.imageUrl) {
    options[positionElement] = {
      ...options[positionElement],
      outerShape: FcShape.SQUARE,
      // use url of top left eye to remove branding
      ...(options[positionElement]?.imageUrl && {
        imageUrl: options.positionElementTopLeft?.imageUrl
      })
    }
  }
}
